import React from 'react';
import { PageContainer, Header, Content, Footer } from 'components/blocks';
import { reSubscribe, changePuaseDuration, updateReason } from 'services/mail';
import PauseEmails from './PauseEmails';

export default function() {
  return (
    <PageContainer>
      <Header title="Pause Emails" />
      <Content>
        <div className="flex items-center" style={{ flexDirection: 'column' }}>
          <PauseEmails
            onChangeDuration={changePuaseDuration}
            onReSubscribe={reSubscribe}
            onUpdateReason={updateReason}
          />
        </div>
      </Content>
      <Footer />
    </PageContainer>
  );
}
